/**
 * Decisões PURAS de roteamento entre os três mundos — testáveis sem renderizar.
 *  A) SITE DE VENDAS (landing pública) — só para quem NÃO é usuário.
 *  B) PLATAFORMA (B2B logado) — login em /entrar; telas internas na raiz.
 *  C) APP DO COMPRADOR (white-label) — /app/{slug}.
 */

export type DestinoAnon = 'landing' | 'login' | 'entrar';

/**
 * Onde vai um visitante DESLOGADO do mundo A/B:
 *  - raiz "/" e NÃO é cliente conhecido E não é app instalado → landing (A);
 *  - raiz "/" e (cliente conhecido OU app instalado/standalone) → login (/entrar)
 *    — nunca a landing. Um PWA INSTALADO é, por definição, de um usuário: mesmo
 *    que tenha sido instalado com start_url "/" antigo, ele abre no LOGIN, não no
 *    site de vendas;
 *  - qualquer outro path → login (nunca a landing).
 */
export function destinoAnon(
  location: string,
  opts: { clienteConhecido: boolean; standalone: boolean },
): DestinoAnon {
  const raiz = location === '/' || location === '';
  if (raiz) return opts.clienteConhecido || opts.standalone ? 'entrar' : 'landing';
  return 'login';
}

/** A rota pertence ao mundo do COMPRADOR (C)? Inclui /app sem slug. */
export function ehMundoComprador(location: string): boolean {
  return location === '/app' || location.startsWith('/app/');
}
